export const categorie = [
    {
        id: 1,
        name: "Développement",
        list: [
            { num: 1, title: "Java", rating: 4 },
            { num: 2, title: "SQL", rating: 3 },
            { num: 3, title: "C", rating: 4 },
            { num: 4, title: "Python", rating: 2 },
            { num: 5, title: "Bash", rating: 4 },
            { num: 6, title: "React", rating: 3 },
            { num: 7, title: "Html & Css", rating: 4 },
        ]
    },
    {
        id: 2,
        name: "Outils",
        list: [
            { num: 1, title: "Intellij Idea", rating: 3},
            { num: 2, title: "Pycharm", rating: 3 },
            { num: 3, title: "VSCode", rating: 3 },
            { num: 4, title: "Git & Github", rating: 4 },
            { num: 5, title: "Android studio", rating: 3 },
            { num: 6, title: "Figma", rating: 3 },
            { num: 7, title: "Notion", rating: 5}
        ]
    },
    {
        id: 3,
        name: "Gestion de projet",
        list: [
            { num: 1, title: "SCRUM", rating: 4},
            { num: 2, title: "Cascade", rating: 2 },
            { num: 3, title: "Cycle en V", rating: 3 },
            { num: 4, title: "Communication", rating: 3 },
            { num: 5, title: "Collaboration", rating: 4 },
            { num: 6, title: "Leadership", rating: 2 },
            { num: 7, title: "Esprit critique", rating: 3 }
        ]
    },
    {
        id: 4,
        name: "OS",
        list: [
            { num: 1, title: "Windows", rating: 3 },
            { num: 2, title: "Ubuntu (Linux)", rating: 3 },
            { num: 3, title: "Debian (Linux)", rating: 4 },
        ]
    },
    {
        id: 5,
        name: "Langues",
        list: [
            { num: 1, title: "Français", rating: 5 },
            { num: 2, title: "Anglais", rating: 3 },
            { num: 3, title: "Espagnol", rating: 1 }
        ]
    },
    {
        id: 6,
        name: "Soft skills",
        list: [
            { num: 1, title: "Communication", rating: 3 },
            { num: 2, title: "Motivation", rating: 5 },
            { num: 3, title: "Curiosité", rating: 4 }
        ]
    }
]